import * as React from 'react';
import PropTypes from 'prop-types';
import range from 'lodash/range';
import { Link } from 'react-router-dom';

const Paging = ({page, totalPages, baseUrl, onPageChange}) => { 
    const onChange = (event, page) => {
        if(onPageChange) {
            event.preventDefault();
            onPageChange(page);
        }
    };

    const getUrl = (page) => {
        if(baseUrl) {
            return `${baseUrl}?page=${page}`;
        }
        else {
            return "#";
        }
    };
    return (
        <div className="paging">
            <div id="pagingContainer">
                <p className="page">PAGE {page} OF {totalPages}</p>
                <div className="pagination-container">
                    <ul className="pagination">
                        {
                            page !== 1 ?
                                <li key="prev" className="PagedList-skipToPrevious">
                                    <Link to={getUrl(page - 1)} onClick={(e) => onChange(e, page - 1)} rel="prev">«</Link></li>
                            : null
                        }
                        {
                            range(1, totalPages + 1).map(i =>
                                <li key={i} className={i == page ? 'active' : ''}>
                                    <Link to={getUrl(i)} onClick={(e) => onChange(e, i)}>{i}</Link>
                                </li>
                            )
                        }
                        {
                            page !== totalPages ?
                                <li key="next" className="PagedList-skipToNext">
                                    <Link to={getUrl(page + 1)} onClick={(e) => onChange(e, page + 1)} rel="next">»</Link>
                                </li>
                            : null
                        }
                    </ul>
                </div>
            </div>
        </div>
    );
};

Paging.propTypes = {
    page: PropTypes.number.isRequired,
    totalPages: PropTypes.number.isRequired,
    baseUrl: PropTypes.string,
    onPageChange: PropTypes.func
};

export default Paging;


